/*
 *
 * Auth constants
 *
 */

export const LOAD_USER_SETTINGS = 'ipfabric/Auth/LOAD_USER_SETTINGS';
